import { render, staticRenderFns } from "./c-head.vue?vue&type=template&id=f571d240&scoped=true&"
import script from "./c-head.vue?vue&type=script&lang=js&"
export * from "./c-head.vue?vue&type=script&lang=js&"
import style0 from "./c-head.vue?vue&type=style&index=0&id=f571d240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f571d240",
  null
  
)

export default component.exports